import React from 'react';
import { useTranslation } from 'react-i18next';
import { BsExclamationTriangleFill } from 'react-icons/bs';

interface OfflineSyncWarningProps {
  className?: string;
}

export const OfflineSyncWarning: React.FC<OfflineSyncWarningProps> = ({ className = '' }) => {
  const { t } = useTranslation('common');

  return (
    <div
      className={`mb-4 flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-500 ${className}`}
    >
      <BsExclamationTriangleFill className="shrink-0 text-base" />
      <span>{t('indexedDbNotSyncedMessage')}</span>
    </div>
  );
};

export default OfflineSyncWarning;
